<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading"
           @on-cancel="cancel" :width="610"
           @on-visible-change="visiableChange"
    >
      <h3 slot="header" class="modal-header"> {{updateId?'修改菜单':'添加菜单'}}</h3>
      <div>
        <Form :model="formData" :label-width="120"  :rules="formRules" ref="formData">
          <FormItem label="父级菜单">
            <div>{{formData.parentName}}</div>
            <Input   class="item-width" v-model="formData.id" style="display: none"></Input>
          </FormItem>
          <FormItem label="所属应用" prop="appType">
            <Select  class="item-width" placeholder="请选择" v-model="formData.appType" :disabled="this.appType && this.appType !== 0">
              <Option v-for="item in appTypeList" :value="item.value" :key="'keyB'+item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="菜单名称" prop="title">
            <Input   class="item-width" v-model="formData.title"></Input>
          </FormItem>
          <FormItem label="url" prop="url">
            <Input  class="item-width" v-model="formData.url"></Input>
          </FormItem>
          <FormItem label="菜单特权" prop="category">
            <Select  class="item-width" placeholder="请选择" v-model="formData.category">
              <Option v-for="item in categoryList" :value="item.value" :key="'keyA'+item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="类型" prop="type">
            <RadioGroup v-model="formData.type">
              <Radio :label=0 :disabled="updateId === ''? false :true">菜单</Radio>
              <Radio :label=1 :disabled="updateId === ''? false :true">功能</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="状态" prop="status">
            <Select  class="item-width" placeholder="请选择" v-model="formData.status">
              <Option v-for="item in statusList" :value="item.value" :key="'keyA'+item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="顺序" prop="orderNum">
            <Input  class="item-width" v-model="formData.orderNum"></Input>
          </FormItem>
          <FormItem label="描述" prop="description">
            <Input  class="item-width" v-model="formData.description"></Input>
          </FormItem>
        </Form>

      </div>
    </Modal>
  </div>
</template>

<script>
  import {menuAdd, menuModify, getMenuDetail} from "../../../../api/systemmanage";

  export default {
    name: "",
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      appType: {
        type: Number,
        default: null
      },
      parentName:{
        type:String,
        default:''
      },
      parentMenuId:{
        type:Number,
        default:0
      },
      updateId:{
        type:[String,Number],
        default:'',
      },
    },
    watch:{
      n(){
        this.clearData();
        this.isShow=true;
        this.initData()
      }
    },
    data(){
      return {
        loading: true,
        isShow:false,
        categoryList:[{text:'平台权限',value:1},{text:'商户权限',value:2},{text:'共享权限',value:3}],
        appTypeList:[{text:'自如寓后台',value:1},{text:'超级ZO',value:2},{text:'一三环境',value:3},{text:'营销平台',value:4}],
        statusList:[{text:'启用',value:0},{text:'停用',value:1}],
        formData:{
          id: '',
          title: '',
          url: '',
          category: null,
          type: null,
          status: 0,
          orderNum: 0,
          description: '',
          parentName:'',
          appType:null

        },
        formRules:{
          title:[{ required: true, message: ' ' ,trigger: 'blur', type:'string'}],
          url:[{ required: true, message: ' ' ,trigger: 'blur', type:'string'}],
          category:[{ required: true, message: ' ' ,trigger: 'change', validator: this.validateNumber}],
          type:[{ required: true, message: ' ' ,trigger: 'blur', validator: this.validateNumber}],
          status:[{ required: true, message: ' ' ,trigger: 'blur', validator: this.validateNumber}],
          appType:[{ required: true, message: ' '}],
          orderNum:[{  required: true, message: '请输入正确数字 ' ,trigger: 'blur',validator: this.validateNumber}],
          // description:[{ required: true, message: ' ' ,trigger: 'blur', type:'string'}],
        },
      }
    },
    methods:{
      visiableChange(value){
        if(!value){
          this.$emit('close')

        }

      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      clearData(){
        this.formData={
          title: '',
          url: '',
          category: null,
          type: null,
          status: 0,
          orderNum: null,
          description: '',
          parentName:'',
          appType:null,
        };
        this.$refs['formData'] &&  this.$refs['formData'].resetFields()
      },
      initData() {
        this.formData.parentName = this.parentName;
        this.formData.appType = this.appType
        if(this.updateId){
          getMenuDetail({id: this.updateId}).then(res => {
            if(!res.data){
              return
            }
            this.formData.parentName = res.data.parentTitle;
            this.formData.id = res.data.id;
            this.formData.title = res.data.title;
            this.formData.url = res.data.url;
            this.formData.category = res.data.category;
            this.formData.type = res.data.type;
            this.formData.status = res.data.status;
            this.formData.orderNum = res.data.orderNum;
            this.formData.description = res.data.description
          }).catch(res=> {
          })
        }
      },
      ok(){
        this.$refs['formData'].validate(bool => {
          if (bool) {
            if(this.formData.appType ===0){
              this.$Message.info('请选择所属应用！');
              this.changeLoading();
              return
            }
            let params={
              parentId:this.parentMenuId,
              ...this.formData
            };
            if(this.formData.id){
              menuModify(params).then(res=>{
                this.$Message.success('修改菜单成功');
                this.$emit('done')

              }).catch(error=>{

              }).finally(()=>{
                this.isShow=false
              })
            }else {
              menuAdd(params).then(res=>{
                this.$Message.success('添加菜单成功');
                this.$emit('done')

              }).catch(error=>{

              }).finally(()=>{
                this.isShow=false
              })
            }
          }
          else {
            if(!this.formData.type && this.formData.type !== 0){
              this.$Message.info('请选择类型！');
              this.changeLoading();
              return
            }
            this.changeLoading()
          }
        })
      },
      cancel(){

      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/;
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
    }

  }
</script>

<style scoped>
  .item-width{
    width: 280px;
  }


</style>
